











import Vue from 'vue'
import { FETCH_VERSION } from '@/store/action-types'

interface ComponentData {
  frontendVersion: string
  backendVersion: string
  dbVersion: string
}

export default Vue.extend({
  name: 'VersionPage',

  data (): ComponentData {
    return {
      frontendVersion: process.env.VUE_APP_VERSION as string,
      backendVersion: '',
      dbVersion: ''
    }
  },

  async mounted() {
    const data = await this.$store.dispatch(FETCH_VERSION)
    this.backendVersion = data.api_version
    this.dbVersion = data.db_version
  }
})
